import type { GeneralLocations } from './general';
import GeneralLocationsImpl from './generalImpl';

export type { GeneralLocations };
export default GeneralLocationsImpl;
